import React from 'react';

const LSST = () => {
    return (
        <div style={{ padding: '2rem', fontFamily: 'Arial, sans-serif' }}>
            <h1> London School of Science and Technology (LSST)</h1>
            <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '1rem' }}>
                <thead>
                <tr style={{ backgroundColor: '#f2f2f2' }}>
                    <th style={thStyle}>Category</th>
                    <th style={thStyle}>Details</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td style={tdStyle}>Type</td>
                    <td style={tdStyle}>Private Higher Education Institution</td>
                </tr>
                <tr>
                    <td style={tdStyle}>Founded</td>
                    <td style={tdStyle}>2003 by Mr. Syed Zaidi</td>
                </tr>
                <tr>
                    <td style={tdStyle}>Campuses</td>
                    <td style={tdStyle}>London (Wembley, Elephant & Castle, Stratford, Park Royal), Luton, Birmingham</td>
                </tr>
                <tr>
                    <td style={tdStyle}>Website</td>
                    <td style={tdStyle}>
                        <a href="https://www.lsst.ac" target="_blank" rel="noopener noreferrer">www.lsst.ac</a>
                    </td>
                </tr>
                <tr>
                    <td style={tdStyle}>Undergraduate Degrees</td>
                    <td style={tdStyle}>
                        BA (Hons) Business Management<br />
                        BSc (Hons) Business and Management<br />
                        BSc (Hons) Digital Marketing<br />
                        BSc (Hons) Health and Social Science<br />
                        BSc (Hons) Health and Wellbeing in Society<br />
                        Diploma in Education and Training
                    </td>
                </tr>
                <tr>
                    <td style={tdStyle}>Postgraduate Degrees</td>
                    <td style={tdStyle}>MSc International Business Management</td>
                </tr>
                <tr>
                    <td style={tdStyle}>Vocational Courses</td>
                    <td style={tdStyle}>
                        HNDs and Diplomas in Business, Computing, Hospitality Management, Digital Marketing, Strategic Management & Leadership
                    </td>
                </tr>
                <tr>
                    <td style={tdStyle}>Teaching Approach</td>
                    <td style={tdStyle}>
                        Student-centered, flexible timetables, one-to-one support<br />
                        94.5% satisfaction in National Student Survey 2025
                    </td>
                </tr>
                <tr>
                    <td style={tdStyle}>Inclusivity & Mission</td>
                    <td style={tdStyle}>
                        Widening participation for underrepresented groups<br />
                        Focus on personal merit<br />
                        Evening and weekend classes for working students
                    </td>
                </tr>
                <tr>
                    <td style={tdStyle}>Facilities</td>
                    <td style={tdStyle}>
                        Modern classrooms, computing labs, learning resource centres, cafés, support services
                    </td>
                </tr>
                <tr>
                    <td style={tdStyle}>Admissions</td>
                    <td style={tdStyle}>
                        Foundation Year available<br />
                        Assessment Day: interview, English & Maths test<br />
                        IELTS 6.0 or equivalent
                    </td>
                </tr>
                <tr>
                    <td style={tdStyle}>Funding</td>
                    <td style={tdStyle}>
                        Eligible for UK government grants and loans<br />
                        External funding encouraged
                    </td>
                </tr>
                <tr>
                    <td style={tdStyle}>Partners & Accreditations</td>
                    <td style={tdStyle}>
                        Partners: De Montfort University, University of West London, London Metropolitan University<br />
                        Accreditations: Matrix Standard, Ofsted recognition for Skills Bootcamps
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    );
};

const thStyle = {
    border: '1px solid #ccc',
    padding: '0.75rem',
    textAlign: 'left',
    fontWeight: 'bold',
};

const tdStyle = {
    border: '1px solid #ccc',
    padding: '0.75rem',
    verticalAlign: 'top',
};

export default LSST;
